module.exports = __webpack_public_path__ + "static/media/tool.090c2cc7.png";